


import '../Styles/Medyaf.css';

import React, {useState,useRef} from 'react';
import food from "../Images/Login/Food.svg"
import logo from "../Images/MainLogo.svg"
import brown from "../Images/Login/background.svg"
import LoginNav from '../Components/LoginNav';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import * as yup from "yup"
import {useFormik} from "formik";
import { useNavigate } from "react-router-dom";
import {CustomerInfo2,fireLoginOtp,verifyLoginOtp} from "../api";
import { BeatLoader } from 'react-spinners';
import { IoIosPhonePortrait } from "react-icons/io";
function Login() {
const { t, i18n } = useTranslation();
const [showOtp, setShowOtp]=useState(false);
const [phoneNumber, setPhoneNumber]=useState("");
const [loggedIn, SetoggedIn]=useState(false);
const [loading, setLoading]=useState(false);
const [token, setToken]=useState();
const [msgAr, setMsgAr]=useState();
const [msgEn, setMsgEn]=useState();
const [errorMsgModel, setErrorMsgModel]=useState(false);
let history = useNavigate();



let phoneRegEx =/^(05)[0-9]{8}$|^(03)[0-9]{8}$|^(3)[0-9]{7}$|^(6)[0-9]{7}$|^(7)[0-9]{7}$/;
 
const Schema= yup.object().shape({
phone: yup.string().required(("validation.phone_required")).matches(phoneRegEx,("validation.phone_not_valid")),
})


const formik = useFormik({
initialValues:{
  phone:"",
},
validationSchema: Schema,
onSubmit,

});
    const phoneRef=useRef();
    const otpRef=useRef();




    async function onSubmit(event){
      if (showOtp) {
        // Handle OTP verification
        handleOtpSubmit(event);
        return;
      }

      // Handle phone number submission
      setLoading(true);
      setErrorMsgModel(false);
      
      const phone = phoneRef.current.value;

      // Use new fire-login-otp endpoint
      fireLoginOtp(phone).then((response) => {
        setPhoneNumber(phone); // Store phone number in state
        setShowOtp(true);
        setLoading(false);
        setErrorMsgModel(false);
      }).catch(function (error) {
        setMsgAr("حدث خطأ في إرسال الكود");
        setMsgEn("Error sending code");
        setErrorMsgModel(true);
        setLoading(false);
      });
  }

  async function handleOtpSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setErrorMsgModel(false);

    const otpCode = otpRef.current ? otpRef.current.value : "";
    const pushToken = localStorage.getItem("pushToken") || ""; // Get pushToken from localStorage or use empty string

    // Use new verify login OTP endpoint with v2 baseURL
    verifyLoginOtp(phoneNumber, otpCode, pushToken).then((response) => {
      // Check if response is successful
      if (response.data.message === "success" && response.data.data) {
        const accessToken = response.data.data.accessToken; // Note: capital T, not underscore
        const userData = response.data.data;
        
        if (accessToken) {
          localStorage.setItem("token", accessToken);
          localStorage.setItem("userPhone", userData.phone || phoneNumber);
          localStorage.setItem("userName", userData.name || "");
          localStorage.setItem("verified", JSON.stringify(true));
          
          SetoggedIn(true);
          setToken(accessToken);
          
          const prev = localStorage.getItem("location");
          var frm = document.getElementsByName('loginForm')[0];
          if (frm) frm.reset();
          setShowOtp(false);
          setLoading(false);

          if (prev == "profile" || prev == "book" || prev == "basket" || prev == "process" || prev == "payment" || prev == "myOrders") {
            history(-1);
          } else {
            history("/");
          }
        } else {
          setMsgAr("حدث خطأ في تسجيل الدخول");
          setMsgEn("Login error occurred");
          setErrorMsgModel(true);
          setLoading(false);
        }
      } else {
        setMsgAr("الكود غير صحيح");
        setMsgEn("Invalid code");
        setErrorMsgModel(true);
        setLoading(false);
      }
    }).catch(function (error) {
      console.error("Login error:", error);
      setMsgAr("الكود غير صحيح");
      setMsgEn("Invalid code");
      setErrorMsgModel(true);
      setLoading(false);
    });
  }

  function resendOtp() {
    setLoading(true);
    setErrorMsgModel(false);

    // Use new fire-login-otp endpoint to resend OTP
    fireLoginOtp(phoneNumber).then((response) => {
      setMsgAr("تم إرسال الكود");
      setMsgEn("Code has been sent");
      setErrorMsgModel(true);
      setLoading(false);
    }).catch(function (error) {
      setMsgAr("حدث خطأ في إرسال الكود");
      setMsgEn("Error sending code");
      setErrorMsgModel(true);
      setLoading(false);
    });
  }

    
    return (
        <div>
             <LoginNav/>
        
        <div className='container-fluid fluid loginContainer'>
            
<div className='container-fluid login'>
{loading?  <div style={{height:"64vh"}} className='loader'>
       <BeatLoader color={'#E47100'} loading={loading}  size={30} /></div>:null}
<div style={loading? {display:"none"}:null} className='row'>
<div className='col'>
    {!showOtp ? (
      <>
        <div className='loginTitle'>
          <p > {t("Login.login")}</p>
        </div>
        <form className='loginForm' name="loginForm" onSubmit={formik.handleSubmit} >
          <label> {t("Login.enterPhone")}</label>
          <input 
            type="text" 
            placeholder={t("Login.yourPhone")} 
            value={formik.values.phone} 
            id="phone" 
            name="phone"  
            ref={phoneRef} 
            required={true} 
            onChange={formik.handleChange} 
            onBlur={formik.handleBlur}  
            className={formik.errors.phone && formik.touched.phone || errorMsgModel?"invalid":null}
            disabled={showOtp}
          />
          <span>{formik.errors.phone && formik.touched.phone?t(`${formik.errors.phone}`):null}</span>
          
          {i18n.language=="ar"?
            <span>{errorMsgModel? msgAr:null}</span>:
            <span>{errorMsgModel? msgEn:null}</span>}
          <button type="submit" style={{marginTop:"3em"}}> {t("Login.login")}</button>
        </form>
        <div className='register'>
          <p> {t("Login.dontHave")}</p>
          <Link to="/register"> <button> {t("Login.register")}</button></Link>
        </div>
      </>
    ) : (
      <>
        <div className='loginTitle'>
          <div style={{marginBottom:"2em"}}>
            <IoIosPhonePortrait size={60} className='fpLogo'/>
            <p className='fp-p1'>{t("Login.checkPhone")}</p>
            <p className='fp-p1'>{t("Login.verify")}</p>
          </div>
        </div>
        <form className='loginForm fpForm' name="loginForm" onSubmit={(e)=>handleOtpSubmit(e)}>
          <div className='fpBody'>
            <div className='fpFormLabel' style={i18n.language=="ar"?{textAlign:"right"}:null}>
              <label>{t("Login.EnterVerify")}</label>
              <div>
                <input 
                  type="text"  
                  id="code" 
                  name="code"  
                  ref={otpRef} 
                  className={errorMsgModel?"invalid":null}
                />
              </div>
            </div>
            <div>
              <div className='fpFormLabel' style={i18n.language=="ar"?{textAlign:"right"}:null}>
                {i18n.language=="ar"?
                  <span>{errorMsgModel? msgAr:null}</span>:
                  <span>{errorMsgModel? msgEn:null}</span>}
                <p onClick={resendOtp} className='resend'>{t("validation.resend")}</p>
              </div>
              <button type='submit'>{t("Login.confirm")}</button>
            </div>
          </div>
        </form>
      </>
    )}
</div>
<div className={i18n.language=="ar"?'col loginImagesAr':'col loginImages'}>
<img className='img1' src={brown} />
<img className='img2' src={food} />
<img className='img3' src={logo} />

</div>
</div>
</div>
</div></div>
    );
}

export default Login;
